import { Handle, NodeProps, Position } from '@xyflow/react';
import StorageIcon from '@mui/icons-material/Storage';
import ApiIcon from '@mui/icons-material/Api';
import PipelineIcon from '@mui/icons-material/AccountTree';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SettingsIcon from '@mui/icons-material/Settings';
import TerminalIcon from '@mui/icons-material/Terminal';
import { Divider, keyframes, styled, Typography } from '@mui/material';
import styles from './CustomNode.module.scss';
import { BglPrimaryOutlinedSmallButton } from 'components/button/BglButtons';
import { GetValues } from 'types/cms/frontendTypes';
import { useGlobalConfig } from 'context/GlobalContext';
import { ROUTE_TREE } from 'routes/AppRoutes';
export interface ServiceNodeData {
  type: 'storage' | 'api' | 'daemon' | 'pipeline' | 'module' | 'product';
  label: string;
  description?: string;
  specifications?: string;
  configs : GetValues<"api::config.config">[];
  positionDocId : string
  [key: string]: unknown;
}

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Create a styled component for the icon
const SpinningIcon = styled(SettingsIcon)`
  animation: ${spinAnimation} 5s linear infinite;
`;

function CustomNode({ data, id }: NodeProps) {

  const { rc } = useGlobalConfig()
  const nodeData = data as unknown as ServiceNodeData;
  
  const navToSpecifications = () => {
    rc.uiRouter.navigate(ROUTE_TREE.WORKFLOW.NODE_DETAILS, {
      id : id
    })
  }

  const getIcon = () => {
    switch (nodeData.type) {
      case 'storage':
        return <StorageIcon />;
      case 'api':
        return <ApiIcon />;
      case 'daemon':
        return <SpinningIcon />
      case 'module':
        return <TerminalIcon />;
      case 'pipeline':
        return <PipelineIcon />;
      case 'product':
        return <AccountBoxIcon />;
      default:
        return null;
    }
  };

  const getColor = () => {
    switch (nodeData.type) {
      case 'storage':
        return '#990000';
      case 'api':
        return '#bd7e09';
      case 'daemon':
        return '#1976d2';
      case 'module':
        return '#bd7e09';
      case 'pipeline':
        return '#1976d2';
      case 'product':
        return '#04782b';
      default:
        return '#04782b';
    }
  }
 
  return (
    <div className={styles.serviceNode}>
      <Handle id='top' type="target" position={Position.Top} />
      <div className={styles.nodeContent}>
        <div className={styles.icon} style={{color: getColor()}}>{getIcon()}</div>
        <Typography sx={{fontSize: '14px', fontWeight: 'bold'}} className={styles.label}>{nodeData.label}</Typography>
      </div>
      <Divider/>
      {nodeData.description && (
        <Typography className={styles.description} variant="caption" color="textSecondary">
          {nodeData.description}
        </Typography>
      )}
      <div className={styles.buttonContainer}>
        <BglPrimaryOutlinedSmallButton sx={{marginBottom: '10px'}} onClick={navToSpecifications}>
          Specifications
        </BglPrimaryOutlinedSmallButton>
        <BglPrimaryOutlinedSmallButton>
          Configs ({nodeData.configs?.length})
        </BglPrimaryOutlinedSmallButton>
      </div>

      <Handle id="bottom" type="source" position={Position.Bottom} />
      
      {
        nodeData.type !== 'storage' && nodeData.type !== 'product' && (
        <Handle id="left" type="target" position={Position.Left} >
          <div style={{transform: 'translate(30px, -50%)', display: 'flex', 
              alignItems: 'center', justifyContent: 'center'}}>
            <StorageIcon sx={{ color: '#990000', fontSize: '16px'}} />
            <Typography variant="caption" color="textSecondary" sx={{marginLeft: '5px', fontWeight: 'bold'}}>
              Input
            </Typography>
          </div>
        </Handle>
        )
      }
      
    </div>
  );
}

export default CustomNode;